// import Vue from 'vue'
// import App from './App.vue'

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')


const moment = require('moment')
require('moment/locale/de')

import Vue from 'vue'
import HomepageEvents from './HomepageEvents.vue'
import Exhibits from './Exhibits.vue'
import vueCustomElement from 'vue-custom-element'
import './plugins/axios'
Vue.use(vueCustomElement)
Vue.use(require('vue-moment'), {
  moment
})
Vue.customElement('homepage-events', HomepageEvents)
Vue.customElement('homepage-exhibits', Exhibits)
